import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IAdminAuditLogDetailResponse,
  IAdminAuditLogResponse,
} from '../../types/api/response/auditlogresponse';
import { IAuditLogFilters, IAuditLogState } from '../../types/store';

const initialState: IAuditLogState = {
  logs: [],
  totalElements: 0,
  filters: {
    navigationId: null,
    userIds: [],
  },
  pagination: { page: 0, size: 20 },
  selectedLog: null,
};

const auditLogSlice = createSlice({
  name: 'auditLogSlice',
  initialState,
  reducers: {
    setLogs: (
      state,
      action: PayloadAction<{ content: IAdminAuditLogResponse[]; totalElements: number }>,
    ) => {
      state.logs = action.payload.content;
      state.totalElements = action.payload.totalElements;
    },
    setSelectedLog: (state, action: PayloadAction<IAdminAuditLogDetailResponse | null>) => {
      state.selectedLog = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<IAuditLogFilters>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPagination: (state, action: PayloadAction<{ page: number; size: number }>) => {
      state.pagination = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.logs = [];
      state.totalElements = 0;
      state.pagination = initialState.pagination;
      state.selectedLog = null;
    },
  },
});

export const { setLogs, setSelectedLog, setFilters, setPagination, resetFilters } =
  auditLogSlice.actions;

export default auditLogSlice.reducer;
